export const BASE_URL = 'https://api.ejward.g-sys.app'
export const VERSION_STRING = 'v1.1.0'